// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#header[data-v-08d06308] {\n  float: right;\n}\n#title[data-v-08d06308] {\n  padding: 10px;\n}\n#main[data-v-08d06308] {\n  height: 100%;\n}\n.btn-sm[data-v-08d06308]{\n  margin-left: 5px;\n}\n.btn-right[data-v-08d06308] {\n  float:right;\n}\n.alert-margin[data-v-08d06308]{\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
